<template>
  <div class="index">
    <router-view v-wechat-title="$route.meta.title"></router-view>
    <div>目录</div>
    <ul class="menu">
      <li class="head">
        <router-link to="/">场馆概况</router-link>
      </li>

      <li>
        <router-link to="/info/gbgk/museumintro">----场馆介绍</router-link>
      </li>
      <li>
        <router-link to="/map">----交通信息</router-link>
      </li>
      <li>
        <router-link to="/info/gbzl">----陈列展览</router-link>
      </li>
      <li>
        <a href="http://www.ycbwg.com/web/wdj.asp">----微建党</a>
      </li>
    </ul>
    <ul class="menu">
      <li class="head">
        <router-link to="/tour">导览讲解</router-link>
      </li>
      <li>
        <router-link to="/info/wmap/map/1/1">----地图导览</router-link>
      </li>
      <li>
        <router-link to="/tour/audio">----语音导览</router-link>
      </li>
      <li>
        <router-link to="/exb">----馆藏精品</router-link>
      </li>
    </ul>
    <ul class="menu">
      <li class="head">
        <router-link to="/service">参观服务</router-link>
      </li>
      <li>
        <router-link to="/service/cgyy">----团体预约</router-link>
      </li>
      <li>
        <router-link to="/service/jiangjie">----讲解时间</router-link>
      </li>
      <li>
        <router-link to="/info/gbgk/visitguide">----参观指南</router-link>
      </li>

      <li>
        <router-link to="/service/feedback">----调查问卷</router-link>
      </li>
      <li>
        <router-link to="/service/lyb">----意见反馈</router-link>
      </li>
      <li>
        <router-link to="/service/contact">----联系我们</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "index",
  data: function() {
    return {
      api_token: "",
      phone: "",
      password: "",
      show: false
    };
  },
  created: function() {
    var vm = this;
  },
  methods: {
    /*加载详情*/
    getToken: function() {
      var vm = this;
      vm.axios({
        method: "post",
        url: "/api/users/login",
        data: {
          p: "w",
          phone: vm.phone,
          password: vm.password
        }
      })
        .then(function(rlt) {
          if (rlt.data.status == 1) {
            vm.api_token = rlt.data.data.api_token;
            localStorage.setItem("api_token", vm.api_token);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.menu {
  padding: 0.5rem 1rem;
}
.menu li {
  font-size: 1rem;
  line-height: 200%;
}
.menu li.head {
  font-size: 1.2rem;
  font-weight: bold;
}

.token {
  padding: 2rem;
}
.token input {
  display: block;
  width: 100%;
  margin-bottom: 1rem;
  padding: 0 0.5rem;
  font-size: 1rem;
  line-height: 200%;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue